import { useState, useCallback } from 'react';
import { useOutletContext } from 'react-router-dom';
import TaskList from '../components/TaskList';
import ViewTaskList from '../components/ViewTaskList';
import NoteEditor from '../components/NoteEditor';

export default function DashboardContent() {
  const {
    selectedFolderId,
    folderName,
    selectedViewId,
    viewName,
    viewRefreshKey,
    folderRefreshKey,
  } = useOutletContext();

  const [editingNoteId, setEditingNoteId] = useState(null);
  const [isCreatingNote, setIsCreatingNote] = useState(false);

  const handleEditNote = useCallback((note) => {
    if (note) {
      setEditingNoteId(note.id);
      setIsCreatingNote(false);
    } else {
      setEditingNoteId(null);
      setIsCreatingNote(true);
    }
  }, []);

  const handleNoteBack = useCallback(() => {
    setEditingNoteId(null);
    setIsCreatingNote(false);
  }, []);

  if (editingNoteId || isCreatingNote) {
    return (
      <NoteEditor
        noteId={editingNoteId}
        folderId={selectedFolderId}
        onBack={handleNoteBack}
      />
    );
  }

  if (selectedViewId) {
    return (
      <ViewTaskList
        viewId={selectedViewId}
        viewName={viewName}
        refreshKey={viewRefreshKey}
        folderRefreshKey={folderRefreshKey}
        onEditNote={handleEditNote}
      />
    );
  }

  return (
    <TaskList
      folderId={selectedFolderId}
      folderName={folderName}
      folderRefreshKey={folderRefreshKey}
      onEditNote={handleEditNote}
    />
  );
}
